import React from 'react';
import { Platform, Share } from 'react-native';

import Chip from '@components/Chip';
import Constants from '@helpers/Constants';
import { logError } from '@helpers/Loggers';
import { Plan } from '@types';

type PlanShareButtonProps = {
  planDoc: Plan;
  sendingUserId: string;
};

export function PlanShareButton({ planDoc, sendingUserId }: PlanShareButtonProps) {
  const getMessage = () => {
    const userText = sendingUserId === planDoc.userId ? 'my' : planDoc.user.displayName + "'s";
    const locationText = planDoc.location.displayName;
    return `I want to share ${userText} plan in ${locationText} with you! Check it out on Joinstar at: ${Constants.joinstar.company.links.landing}`;
  };

  const onPress = async () => {
    try {
      await Share.share({ message: getMessage() });
    } catch (error) {
      logError(error);
    }
  };

  return Platform.select({
    default: (
      <Chip onPress={onPress} icon="export-variant">
        Share
      </Chip>
    ),
    // Share API not available on web
    web: null,
  });
}
